"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = require("@airstudio/state");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const workspace_1 = require("./workspace");
exports.useResourceQuery = ({ path, id }) => {
    const dispatch = react_redux_1.useDispatch();
    const workspaceId = workspace_1.useWorkspace();
    const { errorMessage, isProcessing } = react_redux_1.useSelector(state_1.Selectors.Entities.stateByItemId(path, id));
    const resource = react_redux_1.useSelector(state_1.Selectors.Entities.getItemById(path, id));
    react_1.useEffect(() => {
        if (true /*workspaceId*/ && id && id !== '_') {
            state_1.Operations.Entities.fetchOne(dispatch)(workspaceId, path, id);
        }
    }, [workspaceId, id]);
    return {
        errorMessage,
        isProcessing,
        resource,
    };
};
//# sourceMappingURL=resourceQuery.js.map